import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
// import storageSession from 'redux-persist/lib/storage/session';
import user from './user';
import runtime from './runtime';
import intl from './intl';
import order from './order';
import quoting from './quoting';
import dialog from './dialog';

export default function createRootReducer() {
  return combineReducers({
    user,
    runtime,
    intl,
    order,
    quoting,
    dialog,
  });
}



// WEBPACK FOOTER //
// ./src/reducers/index.js